<ng-template #trainBradcrumbs let-train="train" let-last="last">
  @if (train.type == 'multi' && train.subSegments) {
    @for (t of train.subSegments; track t; let last = $last) {
      <ng-container
        [ngTemplateOutlet]='trainBradcrumbs'
        [ngTemplateOutletContext]='{last:last, train:t}'
      ></ng-container>
    }
  }
  @if (train.type != 'multi') {
    @if (trainTypeImages[train.type]) {
      <img [matTooltip]="train.type" [src]="trainTypeImages[train.type]" class="train-icon"/>
    }
    <small class="train-name"> {{train.name}}</small>
  }
  @if (!last) {
    <span> / </span>
  }
</ng-template>

<div class="train-breacrumbs">
  @for (t of trains; track t; let last = $last) {
    <ng-container
      [ngTemplateOutlet]='trainBradcrumbs'
      [ngTemplateOutletContext]='{last:last, train:t}'
    ></ng-container>
  }
</div>